import React from "react";

const EndSwitchInner = () => {
  return (
      <div className="one3d-continue-button" title="Explore your car in 3D"><span>Explore your car in 3D</span></div>
  );
};

export default EndSwitchInner;
